<template>
      <div class="azNav">
        <div v-for="alpha in artistsAz" :key="alpha" class="letter cursor-pointer" v-on:click="azSelected(alpha)">
          {{alpha}}
        </div>
      </div>
</template>
<script>
export default {
  name: 'app',
  props: {
    artistsAz: Array
  },
  components: {},
  methods: {
    azSelected(alpha) {
      this.$emit('azSelected', alpha);
    }
  }
}

</script>
